import { TIERS, type TierId } from "./tiers";
import styles from "./TierSelect.module.css";

interface TierSelectProps {
  value: TierId;
  onChange: (tier: TierId) => void;
}

/** Horizontal radio-card strip for choosing a starting tier at onboarding. */
export function TierSelect({ value, onChange }: TierSelectProps) {
  return (
    <div className={styles.wrap} role="radiogroup" aria-label="Starting plan">
      {TIERS.map((tier) => {
        const selected = tier.id === value;
        return (
          <button
            type="button"
            key={tier.id}
            role="radio"
            aria-checked={selected}
            className={[styles.tier, selected ? styles.selected : ""].filter(Boolean).join(" ")}
            onClick={() => onChange(tier.id)}
          >
            <span className={styles.name}>{tier.name}</span>
            <span className={styles.price}>{tier.priceLabel}</span>
            <span className={styles.meta}>
              {tier.agents} agents · {tier.channels} {tier.channels === 1 ? "channel" : "channels"}
            </span>
          </button>
        );
      })}
    </div>
  );
}
